var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillReviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bill-review-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large-Copy",
    transform: "translate(-253, -342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(266, 349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invoice-bill-svgrepo-com",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3859091,0 C46.3859091,1.27203125 45.3398587,2.30685547 44.054336,2.30685547 C42.7688133,2.30685547 41.7229011,1.27203125 41.7229011,0 L37.108672,0 C37.108672,1.27203125 36.0627598,2.30685547 34.7773753,2.30685547 C33.4918526,2.30685547 32.445664,1.27203125 32.445664,0 L27.8315731,0 C27.8315731,1.27203125 26.7855227,2.30685547 25.5,2.30685547 C24.2144773,2.30685547 23.1684269,1.27203125 23.1684269,0 L18.554336,0 C18.554336,1.27203125 17.5082856,2.30685547 16.2227629,2.30685547 C14.9372402,2.30685547 13.891328,1.27203125 13.891328,0 L9.27723709,0 C9.27723709,1.27203125 8.2311867,2.30685547 6.94566401,2.30685547 C5.66014133,2.30685547 4.61409094,1.27203125 4.61409094,0 L0,0 L0,70 L4.61409094,70 C4.61409094,68.7279688 5.66014133,67.6931445 6.94566401,67.6931445 C8.2311867,67.6931445 9.27723709,68.7279688 9.27723709,70 L13.891328,70 C13.891328,68.7279688 14.9372402,67.6931445 16.2227629,67.6931445 C17.5082856,67.6931445 18.554336,68.7279688 18.554336,70 L23.1684269,70 C23.1684269,68.7279688 24.2144773,67.6931445 25.5,67.6931445 C26.7855227,67.6931445 27.8315731,68.7279688 27.8315731,70 L32.445664,70 C32.445664,68.7279688 33.4917144,67.6931445 34.7772371,67.6931445 C36.0627598,67.6931445 37.108672,68.7279688 37.108672,70 L41.7227629,70 C41.7227629,68.7279688 42.7688133,67.6931445 44.054336,67.6931445 C45.3398587,67.6931445 46.3859091,68.7279688 46.3859091,70 L51,70 L51,0 M46.3859091,63.5262305 C45.656852,63.2685156 44.8716924,63.1279688 44.054336,63.1279688 C42.2728721,63.1279688 40.6464503,63.7955664 39.4157865,64.8904102 C38.1849846,63.7955664 36.558701,63.1279688 34.7773753,63.1279688 C32.9959114,63.1279688 31.3694896,63.7955664 30.1388258,64.8904102 C28.9080239,63.7955664 27.2816021,63.1279688 25.5002764,63.1279688 C23.7189507,63.1279688 22.0923907,63.7955664 20.8617269,64.8904102 C19.630925,63.7955664 18.0045032,63.1279688 16.2231775,63.1279688 C14.4418518,63.1279688 12.81543,63.7955664 11.5847662,64.8904102 C10.3539642,63.7955664 8.72754244,63.1279688 6.94621675,63.1279688 C6.12886034,63.1279688 5.34370072,63.2683789 4.61464368,63.5262305 L4.61464368,6.47376953 C5.34370072,6.73148438 6.12886034,6.87203125 6.94621675,6.87203125 C8.72768063,6.87203125 10.3541024,6.20443359 11.5847662,5.10958984 C12.8155682,6.20443359 14.4418518,6.87203125 16.2231775,6.87203125 C18.0046413,6.87203125 19.6310631,6.20443359 20.8617269,5.10958984 C22.0925289,6.20443359 23.7189507,6.87203125 25.5002764,6.87203125 C27.2816021,6.87203125 28.908162,6.20443359 30.1388258,5.10958984 C31.3696278,6.20443359 32.9960496,6.87203125 34.7773753,6.87203125 C36.558701,6.87203125 38.1851228,6.20443359 39.4157865,5.10958984 C40.6465885,6.20443359 42.2730103,6.87203125 44.054336,6.87203125 C44.8716924,6.87203125 45.656852,6.73162109 46.3859091,6.47376953 L46.3859091,63.5262305 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.8378835,
    y: 13.9969922,
    width: 18.5550269,
    height: 4.56517578
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 34.031598,
    y: 13.9969922,
    width: 6.13038036,
    height: 4.56517578
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.8378835,
    y: 24.1713281,
    width: 18.5550269,
    height: 4.56517578
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 34.031598,
    y: 24.1713281,
    width: 6.13038036,
    height: 4.56517578
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.8378835,
    y: 34.3456641,
    width: 18.5550269,
    height: 4.56517578
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 34.031598,
    y: 34.3456641,
    width: 6.13038036,
    height: 4.56517578
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 20.8613124,
    y: 50.8565039,
    width: 19.3009424,
    height: 4.56517578
  })), /*#__PURE__*/React.createElement("g", {
    id: "search-(1)",
    transform: "translate(32, 40)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#10575D",
    strokeWidth: 2.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1874164,-1.125 C15.8575401,-1.125 19.1859433,0.367586705 21.5966294,2.7782869 C24.0073132,5.18898472 25.4998909,8.51740369 25.4998909,12.1875455 C25.4998909,14.7731794 24.7509012,17.1823998 23.4682876,19.2259476 L24.3677297,20.1253826 L25.3639228,21.1215688 L26.2400364,21.9976769 L26.6903211,22.4479591 L27.1418937,22.8995295 L31.5909753,27.3486541 L27.3486591,31.5909949 L19.226071,23.4683595 C17.1824909,24.751002 14.7730894,25.5000909 12.1874745,25.5000909 C8.51735083,25.5000909 5.18894764,24.0075042 2.77826147,21.596804 C0.36757768,19.1861062 -1.125,15.8576872 -1.125,12.1875455 C-1.125,8.51740002 0.367566085,5.18897873 2.77823838,2.7782809 C5.18890933,0.367584407 8.51729483,-1.125 12.1874164,-1.125 Z M12.1874745,4.87503637 C10.171304,4.87503637 8.34345678,5.69552129 7.01947709,7.01950868 C5.69549504,8.34349844 4.87501455,10.1713599 4.87501455,12.1875455 C4.87501455,14.203731 5.69549504,16.0315925 7.01947709,17.3555822 C8.34345678,18.6795696 10.171304,19.5000546 12.1874745,19.5000546 C14.2036264,19.5000546 16.0314778,18.6795623 17.3554645,17.3555679 C18.6794451,16.0315796 19.4999345,14.2037245 19.4999345,12.1875455 C19.4999345,10.1713599 18.679454,8.34349844 17.355472,7.01950868 C16.0314923,5.69552129 14.2036451,4.87503637 12.1874745,4.87503637 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#10575D",
    cx: 44,
    cy: 52,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "checked",
    transform: "translate(40.5, 49.5)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 3.2552338 2.73955109 6 8 0.74477654 7.24477651 0 2.73955109 4.49997284 0.744764875 2.50521247"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillReviewIcon);
export default __webpack_public_path__ + "static/media/bill-review-icon.f6f87e446815c2fff595b4a34e8e5821.svg";
export { ForwardRef as ReactComponent };